import { defineComponent as l, createElementBlock as o, openBlock as e, normalizeClass as s, Fragment as m, renderList as c, createBlock as i, createCommentVNode as u, resolveDynamicComponent as p, toRaw as d } from "vue";
import { scrollToElement as C } from "../../../utils/scrollToElement.js";
const y = /* @__PURE__ */ l({
  name: "RevCardCarouselItems",
  __name: "CardCarouselItems",
  props: {
    cardClasses: {},
    items: {},
    center: { type: Boolean }
  },
  setup(f) {
    const n = () => {
      C(document.activeElement, {
        timeout: 50,
        scroll: { behavior: "smooth", block: "nearest", inline: "center" }
      });
    };
    return (r, g) => (e(), o("ul", {
      class: s(["grid grid-flow-col auto-rows-max grid-rows-1 gap-8 pb-20 md:gap-16", r.center ? "w-full justify-center-safe" : "w-max"])
    }, [
      (e(!0), o(m, null, c(r.items, (t, a) => (e(), o("li", {
        key: a,
        class: s(["snap-start list-none", r.cardClasses])
      }, [
        t ? (e(), i(p(d(t)), {
          key: 0,
          onFocus: n
        }, null, 32)) : u("", !0)
      ], 2))), 128))
    ], 2));
  }
});
export {
  y as default
};
